module.exports = __webpack_public_path__ + "static/media/bindQQ2.bc86c1ae.png";